import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  searchArbitratorAllocationAPI,
  submitArbitratorMappingAPI,
} from "../../../api/arbitratorAllocation_api";

export const searchArbitratorAllocationAction = createAsyncThunk(
  "arbitratorAllocation/searchArbitratorAllocation",
  async (payload, { rejectWithValue }) => {
    const response = await searchArbitratorAllocationAPI(payload);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const submitArbitratorMappingAction = createAsyncThunk(
  "arbitratorAllocation/submitArbitratorMapping",
  async (payload, { rejectWithValue }) => {
    const response = await submitArbitratorMappingAPI(payload);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
